import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VisitorPassComponent } from './components/visitor-pass/visitor-pass.component';
import { SecurityPassComponent } from './security-pass.component';
import { UserAdditionalDetailsComponent } from './components/user-additional-details/user-additional-details.component';
import { VisitorEntryComponent } from './components/visitor-entry/visitor-entry.component';
import { HostApprovalComponent } from './components/host-approval/host-approval.component';
import { EmployeeRegistrationFormComponent } from './components/employee-registration-form/employee-registration-form.component';
import { AumyeEmergencyRespondComponent } from './components/aumye-emergency-respond/aumye-emergency-respond.component';
import { HostVisitorStatusComponent } from './components/host-visitor-status/host-visitor-status.component';
import { CreateIncidentComponent } from './components/create-incident/create-incident.component';

const routes: Routes = [
  {
    path: '',
    component: SecurityPassComponent,
    children: [
      {
        path: 'visitor',
        component: VisitorPassComponent,
      },
      {
        path: 'register-details',
        component: UserAdditionalDetailsComponent,
      },
      {
        path: 'guard-verification',
        component: VisitorEntryComponent,
      },
      {
        path: 'host-approval',
        component: HostApprovalComponent,
      },
      {
        path: 'employee-registration',
        component: EmployeeRegistrationFormComponent,
      },
      {
        path: 'emergency-respond',
        component: AumyeEmergencyRespondComponent,
      },
      {
        path: 'manage-visitor',
        component: HostVisitorStatusComponent,
      },
      {
        path: 'create-incident',
        component: CreateIncidentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SecurityPassRoutingModule {}
